import { Swiper } from "swiper";
import type { SwiperOptions } from "swiper/types";
import { Navigation } from "swiper/modules";

export default class BoutiqueShowcaseSlider extends HTMLElement {
  private swiper: Swiper | null = null;

  connectedCallback() {
    if (this.swiper) {
      return;
    }

    const $el = this.querySelector<HTMLElement>(".boutique-showcase__slider");

    if (!$el) {
      return;
    }

    if (($el as any).swiper as Swiper) {
      this.swiper = ($el as any).swiper as Swiper;
      return;
    }

    const $elNext = this.querySelector<HTMLElement>(
      ".boutique-showcase__nav--next",
    );
    const $elPrev = this.querySelector<HTMLElement>(
      ".boutique-showcase__nav--prev",
    );

    const swiperParams: SwiperOptions = {
      modules: [Navigation],
      slidesPerView: "auto",
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    };

    if ($elNext || $elPrev) {
      swiperParams.navigation = {
        ...$elNext && { nextEl: $elNext },
        ...$elPrev && { prevEl: $elPrev },
      };
    }

    this.swiper = new Swiper($el, swiperParams);

    this.updateNavVisibility();
    this.updateArrowVisibility();
    this.swiper.on("resize", () => this.updateNavVisibility());
    this.swiper.on("slideChange", () => this.updateArrowVisibility());
    this.swiper.on("reachEnd", () => this.updateArrowVisibility());
    this.swiper.on("reachBeginning", () => this.updateArrowVisibility());
    this.swiper.on("fromEdge", () => this.updateArrowVisibility());
  }

  private updateArrowVisibility(): void {
    if (!this.swiper) return;
    const $elPrev = this.querySelector<HTMLElement>(
      ".boutique-showcase__nav--prev",
    );
    const $elNext = this.querySelector<HTMLElement>(
      ".boutique-showcase__nav--next",
    );
    if ($elPrev) {
      $elPrev.hidden = this.swiper.activeIndex === 0;
    }
    if ($elNext) {
      $elNext.hidden = this.swiper.isEnd;
    }
  }

  private updateNavVisibility(): void {
    if (!this.swiper) return;
    const count = this.swiper.slides.length;
    const perView =
      typeof this.swiper.params.slidesPerView === "number"
        ? this.swiper.params.slidesPerView
        : 1;
    const hideNav = count <= perView;
    this.classList.toggle(
      "boutique-showcase__slider-wrapper--nav-hidden",
      hideNav,
    );
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}
